import { render, staticRenderFns } from "./Rebrand.vue?vue&type=template&id=4145443a&scoped=true&"
import script from "./Rebrand.vue?vue&type=script&lang=js&"
export * from "./Rebrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4145443a",
  null
  
)

export default component.exports